import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('ServiceItemService', ServiceItemService);

  ServiceItemService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'ServiceItemModalService',
    '$cacheFactory',
  ];

  function ServiceItemService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    ServiceItemModalService,
    $cacheFactory
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'service_items';

    var cache = $cacheFactory('serviceItemsCache');

    var service = {
      getFilterCriteria: getFilterCriteria,
      getServiceItems: getServiceItems,
      getServiceItem: getServiceItem,
      saveServiceItem: saveServiceItem,
      deleteServiceItem: deleteServiceItem,
      changeServiceItemStatus: changeServiceItemStatus,
      openServiceItemFastCreate: openServiceItemFastCreate,
      setDefaultAssociatedProvider: setDefaultAssociatedProvider,
      hasServiceItemsCache: hasServiceItemsCache,
      getServiceItemsCache: getServiceItemsCache,
      setServiceItemsCache: setServiceItemsCache,
      clearServiceItemsCache: clearServiceItemsCache,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filterCriteria = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filterCriteria;
    }

    function openServiceItemFastCreate(item, successCallback) {
      ServiceItemModalService.openServiceItemFastCreateModal(item, successCallback);
    }

    function getServiceItems(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getServiceItem(id, filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = {};
      }

      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        filterCriteria,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function saveServiceItem(item) {
      var method = 'post';
      var url = apiUrl;

      if (item.id) {
        // edit
        method = 'put';
        url += '/' + item.id;
      }

      function success(response) {
        var msg = item.id ? 'SERVICE_ITEM_MODIFIED' : 'SERVICE_ITEM_ADDED';
        utils._successMsg($translate(msg));

        clearServiceItemsCache();

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { service_item: item }, success, failure);
    }

    function deleteServiceItem(item, successCallback) {
      let url = apiUrl + '/' + item.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_SERVICE_ITEM',
            itemName: item.name,
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'SERVICE_ITEM_DELETED',
          };

          clearServiceItemsCache();

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function changeServiceItemStatus(item) {
      let url = apiUrl + '/' + item.id + '?set_status=true';

      let newStatus = item.status === config.ACTIVE ? config.INACTIVE : config.ACTIVE;

      let params = {
        check_if_used: true,
        status: newStatus,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          utils.changeItemStatus(url, item);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    /*function updateServiceItems(action, items, successCallback) {
            // var params = {
            //     body: 'DELETING_SERVICE_ITEMS_WARNING'
            // };

            utils.updateItems(apiUrl, action, items, successCallback);
        }*/

    function saveAssociatedProvider(providerId, serviceItemId) {
      var url = apiUrl + '/' + serviceItemId + '/add_associated_provider';

      return RestResource.request(
        'post',
        url,
        { provider_id: providerId },
        function () {
          var msg = $translate('PROVIDER_ADDED');
          utils._successMsg(msg);

          utils.itemListChanged(providerId);

          return true;
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }

    function setDefaultAssociatedProvider(providerId, serviceItemId, successCallback) {
      var url = apiUrl + '/' + serviceItemId + '/set_default_associated_provider';

      return RestResource.request(
        'put',
        url,
        { provider_id: providerId },
        function () {
          var msg = $translate('DEFAULT_PROVIDER_CHANGED');
          utils._successMsg(msg);

          return successCallback(providerId);
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }

    function hasServiceItemsCache() {
      return cache.get('all') !== undefined;
    }

    function getServiceItemsCache() {
      return cache.get('all');
    }

    function setServiceItemsCache(serviceItems) {
      cache.put('all', serviceItems);
    }

    function clearServiceItemsCache() {
      cache.removeAll();
    }
  }
})();
